import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-save-analisi-scenario-dialog',
  templateUrl: './save-analisi-scenario-dialog.component.html',
  styleUrls: ['./save-analisi-scenario-dialog.component.scss']
})
export class SaveAnalisiScenarioDialogComponent implements OnInit {

  analisiScenarioName = new FormControl();
  
  constructor(
    public dialogRef: MatDialogRef<string>,
  ) { }

  ngOnInit(): void {
  }

  cancel() {
    this.dialogRef.close();
  }

  confirm() {
    this.dialogRef.close(this.analisiScenarioName.value);
  }
}
